/*
 * theTime – v0.13.1 – 2026-09-21
 *
 * @license ISC
 * @author J. Sebergsen Steinberg
 */

import { type TimeDate, theTime, theUTCTime } from "./theTime";
import { theTimeFrom, theUTCTimeFrom } from "./theTimeFrom";
import { aWeekOfTheTime } from "./aWeekOfTheTime";

export {
	type TimeDate,
	theTime,
	theUTCTime,
	theTimeFrom,
	theUTCTimeFrom,
	aWeekOfTheTime,
};

export default theTime;
